import { StyledFaq } from "./Faq.styled";
import { BodyTyp, TitlesTyp } from "../../components/Typography/Typography";
import { FontWeightEnum, IconSizeEnum } from "../../types/AppTypes";
import { useFaq } from "../../hooks/faq.hooks";
import { IconManager } from "../../components/core/IconManager/IconManager";
import { ReactComponent as BackArrowIcon } from "../../icons/arrowLeft.svg";
import { useNavigate } from "react-router-dom";
import { theme } from "../../constants/StyledComponents";
import { FAQS_SUBTITLE, FAQS_TITLE } from "../../constants/Dictionary";
import { Loader } from "../../components/core/Loader/Loader";
import {
  Accordion,
  AccordionVariantEnum,
} from "../../components/core/Accordion/Accordion";

export const Faq = () => {
  const { data, isLoading } = useFaq();
  const navigate = useNavigate();

  return (
    <StyledFaq>
      <IconManager size={IconSizeEnum.LARGE} onClick={() => navigate(-1)}>
        <BackArrowIcon />
      </IconManager>
      <div className="content">
        <div className="title">
          <TitlesTyp variant="1" fontWeight={FontWeightEnum.SEMIBOLD}>
            {FAQS_TITLE}
          </TitlesTyp>
          <BodyTyp variant="3" fontWeight={FontWeightEnum.REGULAR}>
            {FAQS_SUBTITLE}
          </BodyTyp>
        </div>
        {isLoading ? (
          <Loader loading={isLoading} className="spinner" />
        ) : (
          data?.map((faq) => {
            return (
              <div className={"faq"} key={faq.id}>
                <Accordion
                  key={faq.id}
                  label={
                    <BodyTyp fontWeight={FontWeightEnum.SEMIBOLD} variant="2">
                      {faq.question}
                    </BodyTyp>
                  }
                  variant={AccordionVariantEnum.SECONDARY}
                >
                  <div className={"faq-body"}>
                    <BodyTyp
                      fontWeight={FontWeightEnum.REGULAR}
                      variant="2"
                      color={theme.colors.grey_2}
                    >
                      {faq.answer}
                    </BodyTyp>
                  </div>
                </Accordion>
              </div>
            );
          })
        )}
      </div>
    </StyledFaq>
  );
};
